import makeRequest from 'utils/request'

export const getStatus = (id) => {
  const endpoint = `/running-jobs/status/${id}`
  return makeRequest('get', endpoint, null, null)
}
